import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { util, locales } from '@neurotrack/web-core'

Vue.use(VueI18n)

export default new VueI18n({
  locale: util.env.getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || ['en', 'dev-en'],
  messages: locales
})
